import { UseFormReturnType } from '@mantine/form';
import { useMemo } from 'react';

import { TransitDocumentsEnum, TransitHouseConsignment } from '@e-origin/shared';

import { TransitDocuments } from '../../../TransitViewDocuments/TransitDocuments';
import { TransitViewHouseFormValues } from '../../validateTransitViewHouseForm';
import { TransitViewEditGoodsItemFormValues } from './validateTransitViewEditGoodsItemForm';

interface GoodsItemDocumentsProps {
  form: UseFormReturnType<TransitViewHouseFormValues>;
  goodsItemForm: UseFormReturnType<TransitViewEditGoodsItemFormValues>;
  houseConsignment: TransitHouseConsignment;
  editDisabledConditionalForArrival: boolean;
  isArrival: boolean;
}

export interface DocumentItemProps {
  type: TransitDocumentsEnum;
  label?: string;
  code: string;
  referenceNumber?: string;
  dateOfValidity?: string;
  dataSource: any;
  dataSourceIndex: number;
}

export const GoodsItemDocuments: React.FC<GoodsItemDocumentsProps> = ({
  form,
  goodsItemForm,
  houseConsignment,
  editDisabledConditionalForArrival,
  isArrival,
}) => {
  const handleDocumentDelete = (documentType: any, documentIndex: number) => {
    goodsItemForm.setFieldValue(`documents.${documentType}`, [
      ...(goodsItemForm.values.documents[documentType] || []).filter((_, idx) => idx !== documentIndex),
    ]);
  };

  const handleSavingDocument = (savedDocument) => {
    if (savedDocument.docIndex >= 0) {
      const updatedDocuments = goodsItemForm.values.documents[savedDocument.type].map((doc, idx) => {
        if (idx === savedDocument.docIndex) {
          return savedDocument.data;
        }
        return doc;
      });
      goodsItemForm.setFieldValue(`documents.${savedDocument.type}`, updatedDocuments);
    } else {
      goodsItemForm.setFieldValue(`documents.${savedDocument.type}`, [...(goodsItemForm.values.documents[savedDocument.type] || []), savedDocument.data]);
    }
  };

  const previewDocuments = useMemo(
    () => ({
      PreviousDocument: [...(form?.values?.Consignment?.PreviousDocument || []), ...(houseConsignment?.PreviousDocument || [])],
      SupportingDocument: [...(form?.values?.Consignment?.SupportingDocument || []), ...(houseConsignment?.SupportingDocument || [])],
      AdditionalReference: [...(form?.values?.Consignment?.AdditionalReference || []), ...(houseConsignment?.AdditionalReference || [])],
      AdditionalInformation: [...(form?.values?.Consignment?.AdditionalInformation || []), ...(houseConsignment?.AdditionalInformation || [])],
    }),
    [form?.values, houseConsignment],
  );

  return (
    <TransitDocuments
      isArrival={isArrival}
      previewDocuments={previewDocuments}
      documents={goodsItemForm.values.documents}
      onDelete={handleDocumentDelete}
      onSave={handleSavingDocument}
      disabledDocuments={
        !isArrival
          ? [TransitDocumentsEnum.TRANSPORT_DOCUMENT]
          : [TransitDocumentsEnum.PREVIOUS_DOCUMENT, TransitDocumentsEnum.ADDITIONAL_INFORMATION, TransitDocumentsEnum.TRANSPORT_DOCUMENT]
      }
      disabled={editDisabledConditionalForArrival}
      forGoodsItem={true}
    />
  );
};
